import React, { useState } from 'react';
import './ContactForm.scss';
import { Form, Button, Col, Row, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import SocialMedia from '../../components/social';
import { BASE_URL } from "../../config";
import axios from 'axios';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setResponseMessage('');
  
    try {
      await axios.post(`${BASE_URL}/contactus`, formData); // Removed 'response' variable
      setResponseMessage('Message sent successfully!');
    } catch (error) {
      setResponseMessage('Failed to send message. Please try again later.');
    }
  
    setIsSubmitting(false);
  };
  

  return (
    <Container fluid className="contact-container">
      <h1 className="text-center contact-title">Let's Build the Future Together</h1>
      <p className="text-center contact-subtitle">
        Contact us today to discuss your automotive component needs. Our team of experts is ready to provide the perfect solution.
      </p>
      
      <Row className="align-items-stretch">
        {/* Contact Form Section */}
        <Col md={6} className="form-column">
          <h2 className="text-center form-heading">Contact Us</h2>
          <Form onSubmit={handleSubmit} className="contact-form">
            <Form.Group controlId="formName">
              <Form.Label>Name : </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>Email : </Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formPhone">
              <Form.Label>Phone : </Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter your phone number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formMessage">
              <Form.Label>Message : </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter your message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button variant="primary" type="submit" className="submit-button mt-3" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Submit'}
              </Button>
              {responseMessage && <p className="response-message">{responseMessage}</p>}
            </div>
          </Form>
        </Col>

        {/* Contact Details Section */}
        <Col md={6} className="info-column">
          <h2 className="text-center info-heading">Talk To Us</h2>
          <div className="contact-details">
            <div>
              <FontAwesomeIcon icon={faEnvelope} />
              <a className="contact-email" href="mailto:rnirmalkumar@ranglobal.in"> Email: rnirmalkumar@ranglobal.in</a>
            </div>
            <div>
              <FontAwesomeIcon icon={faPhone} />
              <a href="tel:+919962521225"> Phone: +91 9962521225</a>
            </div>
            <div>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <span> Address: 16, Balaji Nagar Industrial Estate, Ambattur, Chennai, Tamil Nadu - 600053, India</span>
            </div>
          </div>

          {/* Embedded Map */}
          <div className="map-container mt-4">
            <iframe
              title="map-location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.630462385247!2d80.1417728!3d13.122580899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52633bb560741b%3A0x8c880d0e9607eada!2sRAN%20Global%20Auto%20Engg%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1743753835532!5m2!1sen!2sin"
              width="100%"
              height="250"
              style={{ border: '0' }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>

          <h4 className="text-center follow-us">Follow Us</h4>
          <div className="social-icons">
            <SocialMedia />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactForm;
